import {
  PricingConfigurationValues,
  PricingValues,
} from '@/services/Pricing/pricing-configuration.service';
import { formRowsToValues, valuesToFormRows } from './pricingFormMapping';

export const pricingValuesEqual = (a: PricingValues, b: PricingValues): boolean =>
  a.variable === b.variable && a.fixed === b.fixed && a.amex === b.amex;

// Round-trips values through the form representation so comparisons use the same
// precision the inputs display, avoiding false diffs from sub-cent/sub-percent noise.
export const normalizeToFormPrecision = (
  values: PricingConfigurationValues,
): PricingConfigurationValues => formRowsToValues(valuesToFormRows(values));

// Returns the next stored overrides after editing one country: drop the entry when
// it matches the baseline (so defaults apply), otherwise upsert the edited values.
export const computeNextValues = (
  existing: PricingConfigurationValues | undefined,
  baseline: PricingConfigurationValues,
  activeCountry: string,
  activeValues: PricingValues,
): PricingConfigurationValues => {
  const normalizedBaseline = normalizeToFormPrecision(baseline);
  const matchesBaseline =
    !!normalizedBaseline[activeCountry] &&
    pricingValuesEqual(activeValues, normalizedBaseline[activeCountry]);

  const nextValues: PricingConfigurationValues = { ...(existing ?? {}) };
  if (matchesBaseline) {
    delete nextValues[activeCountry];
  } else {
    nextValues[activeCountry] = activeValues;
  }
  return nextValues;
};
